// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__258YZ","header":"ClearentDisclaimer_header__1v70F","inner":"ClearentDisclaimer_inner__3hb9L"};